import React from "react";
import { ReactComponent as Logo } from "./trash-2.svg";

import "../Icons.scss";

const TrashIcon = (props) => {
  const { iconClass } = props;
  return (
    <Logo className={iconClass} />
  );
};

export default TrashIcon;